import React, { Component } from 'react';
import {
  Nav,
  NavItem,
  NavbarToggler,
  NavbarBrand
} from 'reactstrap';

import HeaderText from './HeaderText'
import AssessmentHeader from './AssessmentHeader'
import HeaderActiveYearIndicator from './HeaderActiveYearIndicator'
import { throws } from 'assert';

class Header extends Component {
  constructor(props){
    super(props)

    this.state = {
      screen : false,
      sideMenu: true
    }
    this.sidebarToggle = this.sidebarToggle.bind(this);
  }

  sidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-hidden');
    this.setState({sideMenu: !this.state.sideMenu});
  }

  fsidebarToggle() {
    document.body.classList.toggle('sidebar-hidden');
  }

  sidebarMinimize(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-minimized');
  }

  mobileSidebarToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('sidebar-mobile-show');
  }

  asideToggle(e) {
    e.preventDefault();
    document.body.classList.toggle('aside-menu-hidden');
  }

componentDidMount(){
    this.calcWidth();
    window.addEventListener('resize', ()=>{
      this.calcWidth()
    })
}

calcWidth = () => {
  let widthClient = document.documentElement.clientWidth;
      if(widthClient < 991){
        this.setState({screen : true})
      }
      else{
        this.setState({screen:false})
      }
}

  render() {
    let {screen} = this.state
    const {pathname} = this.props.location
    const isEdge = navigator.appVersion.indexOf('Edge') > -1
    return (
      <React.Fragment>
      <header className="app-header navbar">
        <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>&#9776;</NavbarToggler>
        {screen && isEdge ? this.fsidebarToggle: null}
        {/* <a className="logo d-lg-none" href="#"><img src="https://bellwork-cg1.firebaseapp.com/img/masteryprep-logo__green.svg" alt="MasteryPrep Logo" /></a> */}
        <NavbarToggler className="d-md-down-none mr-auto" onClick={this.sidebarToggle}>&#9776;</NavbarToggler>

        {/* <HeaderText screen = {this.state.screen} HeaderTitle={this.props.loadAssessment && this.props.HeaderTitle}  pathname={this.props.location ? this.props.location.pathname : ''} />  */}

        {/* Active year assessment indicator */}
        {(pathname.indexOf('/assessment') > -1 || pathname.indexOf('/users/manage') > -1) &&
         <HeaderActiveYearIndicator {...this.props}/>}

        {this.props.loadAssessment  && !screen && <AssessmentHeader 
          search={this.props.location.search}
          subTestSetId={this.props.subTestSetId}
        />}

      </header>
      {this.props.loadAssessment && screen  && <AssessmentHeader 
          search={this.props.location.search}
          subTestSetId={this.props.subTestSetId}
        />}
      </React.Fragment>
    )
  }
 }

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.js